// Sources for analytics
export const SIGN_UP_PAGE = 'Sign up page';
export const ANON_RECORD_A_REPLY = 'anon-record-a-reply';
export const ANON_CREATOR_SHARE_PAGE = 'anon-creator-share-page';
export const PRIMARY_WEB_APP = 'primary-web-app-onboarding';
export const OPINIONATED_OAUTH_SIGNUP = 'opinionated-oauth-signup';
